  export default {
    "不支持的平台语言环境": "Unsupported platform language environment",

    "环境准备已就绪": "The environment is ready",
    "网络尚未连接，建议开启WIFI或4G网络，否则数据无法更新和保存提交": "The network is not connected, it is recommended to open the WIFI or 4G network, otherwise the data can not be updated and saved to submit",
    "应用启动失败，稍后重试...": "Application startup failed, retry later...",
    "开始启动... ": "Start...",
    "获取开发者选项...": "Get developer options...",
    "网络请求超时": "Network request timeout",
    "网络连接已拒绝": "Network connection denied",

    "开始读取内核版本...": "Start reading kernel version...",
    "内核版本读取完成，当前版本:": "Kernel version read complete, current version:",
    "系统正在维护，稍后重试...": "The system is being maintained and try again later...",
    "内核程序版本获取失败": "Kernel program version failed",
    "开始同步内核程序版本...": "Synchronize kernel program version...",
    "内核程序版本同步完成": "Kernel program version synchronization completed",
    "内核最新版本已经保存，版本号:": "The latest version of the kernel has been saved:",

    "系统已经禁用缓存": "The system has disabled caching",
    "系统已经启用调试模式": "The system has enabled debugging mode",

    "开始检查网络连接情况...": "Start checking network connections...",
    "网络连接成功": "Network connection success",
    "网络尚未连接": "Network not connected",

    "开始同步内核脚本...": "Start synchronizing kernel scripts...",
    "内核脚本下载完成": "Kernel script download complete",
    "开始读取内核脚本...": "Read kernel script...",
    "内核脚本读取成功": "Kernel script read successfully",
    "内核程序脚本下载失败": "Kernel script download failed",
    "开始加载内核程序...": "Load kernel program...",
    "内核程序加载成功": "Kernel program loaded successfully",
    "开始运行内核程序...": "Run kernel program...",
    "内核程序加载失败": "Kernel program load failed",
    "内核程序加载成功": "Kernel program loaded successfully",

    "内核程序开始运行": "Kernel program starts running",
    "重新加载": "Reload",
    "清空所有": "Clear"
  }



// WEBPACK FOOTER //
// ./locales/en.js